import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ShoppingCart from './pages/shopping-cart';
import EBookCatalog from './pages/e-book-catalog';
import EBookDetail from './pages/e-book-detail';
import SignIn from './pages/sign-in';
import SignUp from './pages/sign-up';
import Account from './pages/account';
import Downloads from './pages/downloads';
import AdminLogin from './pages/admin-login';
import AdminDashboard from './pages/admin-dashboard';
import BookManagement from './pages/book-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<EBookCatalog />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/e-book-catalog" element={<EBookCatalog />} />
        <Route path="/e-book-detail" element={<EBookDetail />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/account" element={<Account />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/book-management" element={<BookManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
